import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppService } from 'src/app/app.service';
import { memberMenu, memberMenu2 } from 'src/app/layouts/member-content/member.config';
import { AccountInforData } from 'src/app/shared/interfaces/account.interface';
import { LayoutService } from 'src/app/shared/service/layout.service';
@UntilDestroy()
@Component({
  selector: 'app-my',
  templateUrl: './my.component.html',
  styleUrls: ['./my.component.scss'],
})
export class MyComponent implements OnInit, OnDestroy {
  constructor(private appService: AppService, private router: Router, private layout: LayoutService) {}
  userInfo!: AccountInforData;
  memberLayoutMenu: any;
  memberLayoutMenu2: any;
  isH5!: boolean;
  /** 前一次裝置 */
  prevIsH5!: boolean;
  ngOnInit(): void {
    // 订阅当前登录账号信息
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(v => {
      this.userInfo = v ?? ({} as any);
    });
    this.layout.isH5$.pipe(untilDestroyed(this)).subscribe(x => {
      this.isH5 = x;
      // 如果從H5變到web則會直接導到會員總覽業頁
      if (this.prevIsH5 && !this.isH5 && this.layout.page$.getValue() == MyComponent) {
        this.router.navigate([this.appService.languageCode, 'member', 'account', 'overview']);
      }
      this.prevIsH5 = this.isH5;
    });
    this.layout.memberLayoutUrlParam$.next('my');
    this.memberLayoutMenu = memberMenu;
    this.memberLayoutMenu2 = memberMenu2;
  }
  /**
   * 切換菜單
   *
   * @param item
   * @param index
   */
  selectMenu(item: any, index: number) {
    this.router.navigate([this.appService.languageCode, 'member', item.page]);
  }
  ngOnDestroy(): void {
    this.layout.memberLayoutUrlParam$.next(undefined);
  }
}
